<template>
  <div v-if="result" class="result-container text-center">
    <img class="state-img" :src="faceResult == '01' ? img1 : faceResult == '02' ? img2 : img3" />
    <div class="rem32 mt35">
      <span v-if="faceResult === '01'">请等待处理结果</span>
      <span v-if="faceResult === '02'">审核通过</span>
      <span v-if="faceResult === '03'">审核拒绝</span>
    </div>
    <div class="result-btn">
      <van-button round block color="#4D7BFE" v-if="faceResult == '01'" class="btn" @click="queryResult">
        <span class="rem34">查询结果</span>
      </van-button>
      <van-button round block color="#4D7BFE" v-if="faceResult === '02'" class="btn" @click="toBorrow">
        <span class="rem34">去分期</span>
      </van-button>
      <van-button round block color="#4D7BFE" v-if="faceResult === '03'" class="btn" @click="toIndex">
        <span class="rem34">返回首页</span>
      </van-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Vue from 'vue'
import { Button } from 'vant'
import { loanApplyCheckApi } from '@/apis/borrow'

Vue.use(Button)
export default {
  data() {
    return {
      img1: require('@/assets/images/payment/result1.png'),
      img2: require('@/assets/images/kdb/examine-agree.png'),
      img3: require('@/assets/images/kdb/examine-refuse.png'),
      result: true,
      faceResult: '01',
    }
  },
  created() {
    // this.loanApplyCheck()
  },
  computed: {
    ...mapState({
      loanNo: (state) => state.borrow.loanNo,
      faceToken: (state) => state.borrow.faceToken,
      productCode: (state) => state.common.productCode,
      applySeq: (state) => state.borrow.applySeq,
    }),
  },
  methods: {
    // 刷脸后 用于后端跑校验规则
    loanApplyCheck() {
      loanApplyCheckApi(this.loanNo)
        .then((res) => {
          if (res.code === 200) {
            this.faceResult = '02'
          } else {
            this.faceResult = '01'
          }
          this.result = true
        })
        .catch((err) => {
          this.faceResult = '03'
          this.result = true
        })
    },
    queryResult() {
      this.loanApplyCheck()
    },
    toIndex() {
      this.$router.push({ path: this.$store.state.common.defaultIndex })
    },
    toBorrow() {
      this.$router.push('/confirm-borrow')
    },
  },
}
</script>

<style lang="less" scoped>
.result-container {
  padding: 0 0.42rem /* 21/50 */;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  position: relative;
  .state-img {
    margin-top: 1rem;
    width: 4.22rem;
    height: 3.26rem;
  }
  .result-btn {
    position: absolute;
    margin-top: 0.82rem /* 41/50 */;
    bottom: 2.3rem;
    width: calc(100% - 0.84rem);
  }
  .btn {
    margin-top: 0.48rem /* 24/50 */;
  }
}
</style>
